import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api/v2`;
export const ADMIN_SLUG = (process.env.REACT_APP_ADMIN_PATH || "/accountmanager").replace(/\//g, "");
export const ADMIN_PATH = `/${ADMIN_SLUG}`;

export function makeClient(storagePrefix, authBase) {
  const client = axios.create({ baseURL: API });
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem(`${storagePrefix}_token`);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers["Accept-Language"] = localStorage.getItem("rp_lang") || "es";
    return config;
  });
  client.interceptors.response.use(
    (r) => r,
    async (error) => {
      const original = error.config;
      const status = error.response?.status;
      if ((status === 401 || (storagePrefix === "rpa" && status === 404)) && !original._retried && original.url !== `${authBase}/refresh`) {
        const refresh = localStorage.getItem(`${storagePrefix}_refresh`);
        if (refresh) {
          original._retried = true;
          try {
            const { data } = await axios.post(`${API}${authBase}/refresh`, { refresh_token: refresh });
            localStorage.setItem(`${storagePrefix}_token`, data.access_token);
            localStorage.setItem(`${storagePrefix}_refresh`, data.refresh_token);
            original.headers.Authorization = `Bearer ${data.access_token}`;
            return axios(original);
          } catch (e) {
            localStorage.removeItem(`${storagePrefix}_token`);
            localStorage.removeItem(`${storagePrefix}_refresh`);
          }
        }
      }
      return Promise.reject(error);
    }
  );
  return client;
}

export function apiErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return fallback || error?.message || "Error";
}
